import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';

import { CateringOptionsListRow_cateringOption$key } from '__generated__/CateringOptionsListRow_cateringOption.graphql';

type Props = SortableEntityTableRowProps & {
  cateringOption: CateringOptionsListRow_cateringOption$key;
};

const CateringOptionsListRow: FC<Props> = ({ cateringOption, ...props }) => {
  const cateringOptionData = useFragment(
    graphql`
      fragment CateringOptionsListRow_cateringOption on CateringOption {
        id
        name
        etgKey
        displayInSearch

        ...SortableEntityTableRow_entity
      }
    `,
    cateringOption
  );

  const { id, name, etgKey, displayInSearch } = cateringOptionData;

  return (
    <SortableEntityTableRow entity={cateringOptionData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>

      <TableCell center>{etgKey}</TableCell>
      <TableCell center>{displayInSearch ? 'Taip' : 'Ne'}</TableCell>
    </SortableEntityTableRow>
  );
};

export default CateringOptionsListRow;
